import {googleLogout} from '@react-oauth/google'
import {
  Button,
  Dialog,
  DialogTrigger,
  Heading,
  Modal,
  ModalOverlay,
  Text,
} from 'react-aria-components'

import isInApp from '@/lib/in-app/utils/isInApp'
import {logout} from '@/services/authenticationService'
import postMessageToReactNative from '@/utils/postMessageToReactNative'

import style from './LogoutDialog.module.scss'

interface Props {
  onLogout?: () => void
}

const LogoutDialog = deepMemo<PropsWithChildren<Props>>(function LogoutDialog(props) {
  const router = useRouter()
  const latestOnLogout = useStableCallback(props.onLogout)

  const onLogout = useCallback(
    (action: () => void) => {
      latestOnLogout()
      action()
      logout({})
        .then(() => {
          if (isInApp()) {
            postMessageToReactNative({
              type: 'google-logout',
            })
          }
          googleLogout()
        })
        .finally(() => {
          void router.invalidate()
        })
        .catch(() => {
          // empty
        })
    },
    [router],
  )

  return (
    <DialogTrigger>
      {props.children}
      <ModalOverlay
        // TODO: add animation
        className={({isEntering, isExiting}) =>
          clsx(style.Overlay, isEntering && style.IsEntering, isExiting && style.IsExiting)
        }
        isDismissable
      >
        <Modal className={style.Modal}>
          <Dialog className={style.Dialog}>
            {({close}) => (
              <>
                <Heading className={style.Heading} slot='title'>
                  Log out
                </Heading>
                <div className={style.Description}>
                  <Text>Are you sure you want to log out?</Text>
                </div>
                <div className={style.Action}>
                  <Button className={style.Cancel} onPress={close}>
                    Cancel
                  </Button>
                  <Button
                    className={style.Ok}
                    onPress={() => {
                      onLogout(close)
                    }}
                  >
                    Log out
                  </Button>
                </div>
              </>
            )}
          </Dialog>
        </Modal>
      </ModalOverlay>
    </DialogTrigger>
  )
})()

export default LogoutDialog
